import { create } from "zustand";
import { LANGUAGES } from "@/shared";

interface LoginDataStore {
  isUpdatedLanguage: LANGUAGES | null;
  isLoginState: boolean;
  is2FaVerification: boolean;
  setIs2FaVerification: (is2FaVerification: boolean) => void;
  setIsLoginState: (isLoginState: boolean) => void;
  setIsUpdatedLanguage: (isUpdatedLanguage: LANGUAGES | null) => void;
}

export const useLoginDataStore = create<LoginDataStore>()(set => ({
  isUpdatedLanguage: null,
  isLoginState: false,
  is2FaVerification: false,
  setIs2FaVerification: (is2FaVerification: boolean) =>
    set({ is2FaVerification }),
  setIsLoginState: isLoginState => set({ isLoginState }),
  setIsUpdatedLanguage: isUpdatedLanguage => set({ isUpdatedLanguage })
}));
